<template>
  <div class="enterGameWrap">
    <div v-show="live.isGamePlaying" @click="joinGame" class="enterBt">
      {{ $i18n('enterGame', '进入游戏') }}
    </div>
    <div
      style="bottom: 10px"
      @click="joinLottery"
      class="enterBt"
      v-show="live.isLotteryPlaying&&showJoin"
    >
      {{ $i18n('joinLottery', '加入抽奖') }}
    </div>
    <LotteryParticipants ref="lotteryRef" v-if="userInfo && userInfo.id"
                         @exit="handleExit"
                         :draw-id="drawingId"
                         :current-user-id="userInfo.id"
                         :cost-coins="lottery.maxDeductGoldCoin"
                         :visible.sync="showControl"/>
  </div>
</template>
<script>
import {Toast} from "vant";
import {mapGetters, mapState} from "vuex";
import LotteryParticipants from "@/views/home/model/popup/LotteryParticipants"
import {_code} from "@utils/constant";
import i18nMixin from "@/libs/i18nMixin";

export default {
  name: "EnterLive",
  mixins: [i18nMixin],
  components:{
    LotteryParticipants
  },
  data(){
    return{
      showControl:false,
      showJoin:false,
      participants:[]
    }
  },
  computed:{
    ...mapGetters(["live", "lottery"]),
    ...mapState({
      drawingId: (state) => state.live.drawingId,
      userInfo: (state) => state.userInfo,
      lottery: (state) => state.lottery
    }),
  },
  created() {
    if(!this.drawingId)return;
    this.handleDrawInit(this.drawingId);
  },
  methods: {
    handleDrawInit(drawId){
      console.log('初始化抽奖',drawId);
      const promiseInfo = this.$http.get(`/api/lottery/getDrawInfo?drawId=${drawId}`);
      const promiseState = this.$http.get(`/api/lottery/getJoinDrawState?drawId=${drawId}`);
      const promiseRatio = this.$http.get(`/api/lottery/getRatio?drawId=${drawId}`);
      Promise.all([promiseInfo,promiseState,promiseRatio]).then(resp=>{
        const respInfo = resp[0].data;
        this.$store.commit("lottery/setLottery", respInfo);
        // 道具抽奖
        if(respInfo.drawModel){
          // 处理状态
          const respState = resp[1].data;
          if(respState){
            this.showControl = true;
          }else{
            this.showJoin = true;
          }
          //处理中奖概率
          this.$refs.lotteryRef.myBaseRate = resp[2].data;
        }else{
          this.showControl = false;
          this.showJoin = false;
        }
      })
    },
    handleExit(drawId){
      this.$http.get(`/api/lottery/quitDraw?drawId=${drawId}`).then(()=>{
        this.showJoin = true;
      });
    },
    async joinLottery() {
      if(!this.drawingId){
        this.$toast.fail({message:"抽奖不存在!"});
        return;
      }
      await this.$http.post('/api/lottery/joinDraw',this.lottery);
      const res = await this.$http.get(`/api/lottery/getRatio?drawId=${this.drawingId}`);
      this.$toast.success("加入成功，等待抽奖!");
      this.showJoin = false;
      this.showControl = true;
      this.$refs.lotteryRef.myBaseRate = res.data;
    },
    async joinGame() {
      let param = {
        id: this.live.playingGameId,
      };
      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$i18n('loading', '加载中...'),
      });
      try {
        // 第一步：获取正在进行的游戏
        const gameRes = await this.$http.get("/api/liveGame/getDoingLiveGame", { params: param });
        // 第二步：加入游戏
        const joinRes = await this.$store.dispatch("liveGame/joinGame", gameRes.data.id);
        try {
          await this.$store.dispatch("liveGame/getLiveGame", gameRes.data.id);
        } catch (e) {
          console.warn("同步游戏状态失败：", e); // 软失败，不拦截进入
        }
        if (this.$store.state.liveGame.status === 2) {
          this.$toast(this.$i18n('gameEnded', '游戏已结束'));
          return; // END_GAME 推送随后会把按钮收掉，这里不用手动 closeGameReady
        }
        // 处理加入游戏后的响应
        if (joinRes.gameUrl) {
          if (joinRes.gameUrl.startsWith("https://")) {
           await this.$router.replace({
              path: "/iframe",
            });
          } else {
            const url = new URL(joinRes.gameUrl, window.location.origin);
            // 2. 单独提取 liveGameUserId
            const liveGameUserId = url.searchParams.get('liveGameUserId');
            console.log('单独提取的活动用户 id:', liveGameUserId);
            if (liveGameUserId) {
              this.$store.commit('liveGame/SET_LIVE_GAME_USER_ID', liveGameUserId);
            }
            await this.$router.replace({
              path: joinRes.gameUrl,
            });
          }
        } else {
          this.$toast(this.$i18n('gameNotExist', '游戏不存在！'));
        }
      } catch (err) {
        this.$toast.fail({message:this.$i18n('gameNotStarted', '游戏未开始!')});
      } finally {
        toast.clear();
      }
    },
    handleSocketMessage(msg){
      switch (msg.msgType) {
        case _code.BREAK_EGG: // 砸单，清除活动
        case _code.CLEAR_LIVE: // 清除活动
          this.$store.commit("live/closeGameReady");
          this.$store.commit("live/closeLottery");
          break;
        case _code.INIT_LOTTERY: //发起抽奖
          let jsonData = JSON.parse(msg.data);
          if(jsonData.drawModel){
            this.$store.commit("lottery/setLottery", jsonData);
            this.$store.commit("live/showLotteryReady", jsonData);
            this.handleDrawInit(jsonData.id);
          }
          break;
        case _code.READY_GAME: // 准备游戏
          this.$store.commit("live/showGameReady", msg);
          this.$store.dispatch("live/fetchLive", this.live.id);
          break;
        case _code.END_GAME: // 结束游戏
          this.$store.commit("live/closeGameReady");
          this.$store.commit("live/closeLottery");
          break;
        case _code.CLOSE_LOTTERY: // 关闭抽奖
          this.$store.commit("live/closeGameReady");
          this.$store.commit("live/closeLottery");
          break;
      }
    }
  },
  async mounted() {
    if (!this.userInfo || !this.userInfo.id) {
      await this.$store.dispatch('USERINFO');
    }
    // 1. 定义处理函数，绑定 this
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  beforeDestroy() {
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
  },
};
</script>

<style lang="less" scoped>
.enterGameWrap {
  width: 100vw;
  position: fixed;
  bottom: 150px; /* 原300px */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .enterBt {
    width: 234px; /* 原468px */
    height: 40px; /* 原79px */
    line-height: 40px; /* 原79px */
    background: #28c76f;
    border-radius: 23px; /* 原45px */
    font-size: 17px; /* 原34px */
    font-family: PingFang SC;
    text-align: center;
    font-weight: 500;
    color: #ffffff;
    letter-spacing: 10px; /* 原20px */
  }
}
</style>
